import { InteractionStatus } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useEffect, type ReactNode } from "react";
import { Splash } from "@/components/full-page";
import { startLogin } from "./msal";

/**
 * Renders children only for a signed-in user. When there is no account and no
 * MSAL interaction is in flight, it starts a login redirect.
 */
export function AuthGate({ children }: { children: ReactNode }) {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  useEffect(() => {
    if (!isAuthenticated && inProgress === InteractionStatus.None) startLogin("select_account");
  }, [isAuthenticated, inProgress]);

  if (!isAuthenticated) return <Splash label="Signing you in…" />;
  return <>{children}</>;
}

export function useSignOut() {
  const { instance } = useMsal();
  return () => {
    void instance.logoutRedirect({ account: instance.getActiveAccount() ?? undefined });
  };
}
